import { usePromptInjection } from "src/hooks/useToolActions";
import { useStore } from "src/stores";
import {
  QualityEventDefinition,
  QualityEventRecord,
} from "src/types/quality-events";

export const useOpenQualityEventAgent = () => {
  const { uiStore } = useStore();
  const { injectPrompt } = usePromptInjection();
  return (definition: QualityEventDefinition, record?: QualityEventRecord) => {
    uiStore.setIsRightPanelOpen(true);
    const skillContext =
      definition.definition.agentSkills?.[record ? "edit" : "create"];
    injectPrompt({
      prompt: record
        ? `Edit ${definition.name}: ${record.title}.`
        : `Create ${definition.name}.`,
      preview: record ? `Edit ${record.title}` : `Create ${definition.name}`,
      source: "quality-event-record-agent",
      replaceInput: true,
      submit: true,
      newThread: true,
      skillContexts: skillContext ? [skillContext] : [],
    });
  };
};
